import { theme } from '@Guidelines/Theme/theme';

export type TypeSeries = { readonly fill: string; readonly dimmed: string };

/** Colours of one type: by rank for an active type, the neutral series for an archived one. */
const resolveTypeSeries = (rank: number, isArchived: boolean): TypeSeries => {
	if (isArchived) {
		return theme.home.typeSeriesOther;
	}

	return theme.home.typeSeries[rank % theme.home.typeSeries.length] ?? theme.home.typeSeriesOther;
};

export default resolveTypeSeries;
